import React from 'react';
import { ThemeProvider } from 'styled-components';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'; //← Bridge React and Redux
import './index.css';
import App from './App';
//eslint-disable-next-line
import theme from 'theme';
import { buildStore } from './store/configureStore';

let widgetConfigs = {};

const widgetsKeys = [];

const load = () => {
  const widgets = document.querySelectorAll('.matchcenter-widget');

  for (let i = 0; i < widgets.length; i += 1) {
    let widget = widgets[i];
    let widgetId = widget.getAttribute('id');

    if (widgetsKeys.includes(widgetId)) {
      const newWidget = /** @type { Element } */ (widget.cloneNode());
      widgetId = `${widgetId}_${Math.floor(Math.random() * 10000)}`;
      newWidget.setAttribute('id', widgetId);

      ReactDOM.unmountComponentAtNode(widget);
      widget.replaceWith(newWidget);
      widget = newWidget;
    } else {
      widgetsKeys.push(widgetId);
    }

    widgetConfigs = {
      widgetType: widget.getAttribute('data-widgettype'),
      widgetId,
      competitionId: widget.getAttribute('data-competitionid'),
      sportId: widget.getAttribute('data-sportid'),
      matchId: widget.getAttribute('data-matchid'),
      teamId: widget.getAttribute('data-teamid'),
      hometeam: widget.getAttribute('data-hometeam'),
      awayteam: widget.getAttribute('data-awayteam'),
      lightSkin: JSON.parse(widget.getAttribute('data-lightskin')),
      oldestFirst: JSON.parse(widget.getAttribute('data-oldestfirst')),
      pulseLive: JSON.parse(widget.getAttribute('data-pulselive')),
      noFavStar: JSON.parse(widget.getAttribute('data-nofavstar')),
      noLogo: JSON.parse(widget.getAttribute('data-nologo')),
      fullView: JSON.parse(widget.getAttribute('data-fullview')),
      newspaper: widget.getAttribute('data-newspaper'),
      selectedSportIds: widget.getAttribute('data-selectedsportids'),
      isMainSection: JSON.parse(widget.getAttribute('data-ismainsection')),
      matches: widget.getAttribute('data-matches'),
      seasonId: widget.getAttribute('data-seasonId'),
      widgetTitle: widget.getAttribute('data-widget-title'),
      day: widget.getAttribute('data-day'),
      phase: widget.getAttribute('data-phase'),
      subphase: widget.getAttribute('data-subphase'),
      optaType: widget.getAttribute('data-optaType'),
    };

    /**
     * Multiple stores to be able to have more widgets.
     * @todo Refactor by using a single store because Redux DevTools don't
     * work with multiple store. We're using multiple stores because
     * CupCalendarCorriereWidget can't handle dynamic updates or multiple
     * widgets on admin corriere nazionale
     * ( multiple data coexist in same widget.. e.g. Serie-A and Champions ).
     */
    const store = buildStore();

    ReactDOM.render(
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <App widgetConfigs={widgetConfigs} />
        </ThemeProvider>
      </Provider>,
      document.getElementById(widgetConfigs.widgetId),
    );
  }
};

load();

//window.rcsOrchestrator.eventManager.addEventListener('RCSMcWidget:load', load);



// WEBPACK FOOTER //
// ./src/index.js